// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.u64().primaryKey(),
  worldId: __t.u64().name("world_id"),
  encounterId: __t.u64().name("encounter_id"),
  index: __t.u32(),
  state: __t.u8(),
  openedAt: __t.timestamp().name("opened_at"),
  planningWindowS: __t.u32().name("planning_window_s"),
  deadlineAt: __t.option(__t.timestamp()).name("deadline_at"),
  graceUntil: __t.option(__t.timestamp()).name("grace_until"),
  locked: __t.bool(),
  lockReason: __t.u8().name("lock_reason"),
  snapshotHash: __t.byteArray().name("snapshot_hash"),
  planHash: __t.byteArray().name("plan_hash"),
  draws: __t.byteArray(),
  logBlob: __t.byteArray().name("log_blob"),
  unready: __t.array(__t.identity()),
  unresolved: __t.byteArray(),
  seq: __t.u32(),
  lockedAt: __t.option(__t.timestamp()).name("locked_at"),
});
